import type {DropdownMenuItemMixed} from '@gravity-ui/uikit';

export const useAdditionalWorkbookActions = (): DropdownMenuItemMixed<unknown>[] => {
    return [];
};
